import React, { PropsWithChildren } from "react";
import Sidebar from "./Sidebar";
import Searchbar from "./Searchbar";

const Layout = (props: PropsWithChildren<{}>) => {
  return (
    <div className={`tw-w-screen tw-flex tw-flex-col tw-relative tw-font-noto-sans relative`}>
      {/* top */}
      <div className={`tw-h-[60px]  tw-border tw-z-50`}>
        <Searchbar />
      </div>

      {/* bottom */}
      <div className={`tw-h-[calc(100vh-60px)] tw-flex-grow tw-flex tw-relative tw-z-10`}>
        <div className={`tw-max-h-full tw-overflow-auto tw-min-w-fit`}>
          <Sidebar />
        </div>
        <main className={`tw-max-h-full tw-max-w-full tw-overflow-auto tw-flex-grow tw-pt-3 tw-px-4 `}>
          <div className={`tw-w-full tw-min-h-full tw-flex tw-flex-col`}>{props.children}</div>
        </main>
      </div>
      <div id="tooltip-portal"></div>
      <div id="sidepanel-portal" className ="tw-z-[2030]"/>
    </div>
  );
}

export default Layout;
